import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import "./alumni_speak.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <RiArrowRightSLine size={25} />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <RiArrowLeftSLine size={25} />
  </div>
);

const getSlidesToShow = (width) => {
  if (width <= 768) return 1;
  return 2;
};

const AlumniSpeak = () => {
  const [alumniData, setAlumniData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow(window.innerWidth));

  useEffect(() => {
    const fetchAlumni = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/alumni-speak/public`);
        if (!res.ok) throw new Error("Failed to fetch alumni");
        const data = await res.json();
        const mapped = (data.alumni || []).map((item) => ({
          name: item.student_name,
          designation: item.designation,
          company: item.placed_company,
          year: item.passout_year,
          message: item.student_message,
          photo: item.student_photo
            ? `${API_BASE}${item.student_photo}`
            : "https://via.placeholder.com/100",
        }));
        setAlumniData(mapped);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchAlumni();
  }, []);

  useEffect(() => {
    const handleResize = () => setSlidesToShow(getSlidesToShow(window.innerWidth));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <section className="alumni-section">
      <h1 className="title">Our Alumni</h1>
      <h2 className="subtitle">Inspiring journeys from our proud graduates</h2>

      {loading && <p>Loading...</p>}
      {error && <p>{error}</p>}

      {!loading && alumniData.length > 0 && (
        <div className="alumni-carousel">
          <Slider key={slidesToShow} {...settings}>
            {alumniData.map((alumni, index) => (
              <div key={index}>
                <div className="alumni-card">
                  <div className="alumni-top">
                    <div className="alumni-photo">
                      <img src={alumni.photo} alt={alumni.name} />
                    </div>
                    <div className="alumni-info">
                      <h3 className="ach-name">{alumni.name}</h3>
                      <p className="designation">{alumni.designation}</p>
                      <p className="designation">{alumni.company}</p>
                    </div>
                  </div>
                  <div className="message">
                    <FaQuoteLeft className="quote-icon left" />
                    <p>{alumni.message}</p>
                    <FaQuoteRight className="quote-icon right" />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}
    </section>
  );
};

export default AlumniSpeak;
